<template>
  <page-header-wrapper>
    <a-card :bordered="false" style="margin-bottom: 16px">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-statistic
            title="待提现总额"
            :value="statisticsData.undeliveredTotal || 0"
            :precision="2"
            prefix="¥"
            :value-style="{ color: '#ff4d4f' }"
          />
        </a-col>
        <a-col :span="12">
          <a-statistic
            title="已提现总额"
            :value="statisticsData.withdrawnTotal || 0"
            :precision="2"
            prefix="¥"
            :value-style="{ color: '#52c41a' }"
          />
        </a-col>
      </a-row>
    </a-card>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="提现单号">
                <a-input v-model="queryParam.withdrawalNo" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="用户手机号">
                <a-input v-model="queryParam.phone" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="姓名">
                <a-input v-model="queryParam.nameA" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="提现账户">
                <a-select placeholder="请选择" v-model="queryParam.withdrawalAccount" style="width: 100%" allow-clear>
                  <a-select-option :value="0">余额</a-select-option>
                  <a-select-option :value="1">押金</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="提现类型">
                <a-select placeholder="请选择" v-model="queryParam.withdrawalType" style="width: 100%" allow-clear>
                  <a-select-option :value="0">支付宝</a-select-option>
                  <a-select-option :value="1">微信</a-select-option>
                  <a-select-option :value="2">银行卡</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="审核状态">
                <a-select placeholder="请选择" v-model="queryParam.withdrawalState" style="width: 100%" allow-clear>
                  <a-select-option :value="0">审核中</a-select-option>
                  <a-select-option :value="1">款项处理中</a-select-option>
                  <a-select-option :value="2">提现成功</a-select-option>
                  <a-select-option :value="3">提现失败</a-select-option>
                  <a-select-option :value="4">打回</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="是否已审核">
                <a-select placeholder="请选择" v-model="queryParam.checkedAud" style="width: 100%" allow-clear>
                  <a-select-option :value="0">未审核</a-select-option>
                  <a-select-option :value="1">已审核</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" v-if="advanced">
              <a-form-item label="创建时间">
                <a-range-picker
                  v-model="createTimeValue"
                  format="YYYY-MM-DD"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangeCreateTime"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" v-if="advanced">
              <a-form-item label="处理时间">
                <a-range-picker
                  v-model="examineTimeValue"
                  format="YYYY-MM-DD"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangeExamineTime"
                />
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 18" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="handleAuditStatistics" v-hasPermi="['sys:fund:withdrawal:query']">
          <a-icon type="bar-chart" />审核统计
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['sys:fund:withdrawal:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <!-- <a-button type="primary" @click="handleExport" v-hasPermi="['sys:fund:withdrawal:export']">
          <a-icon type="download" />导出
        </a-button> -->
      </div>

      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
      >
        <span slot="withdrawalType" slot-scope="text, record">
          <a-tag :color="getWithdrawalTypeColor(record.withdrawalType)">
            {{ getWithdrawalTypeText(record.withdrawalType) }}
          </a-tag>
        </span>
        <span slot="withdrawalAccount" slot-scope="text, record">
          <a-tag :color="record.withdrawalAccount === 0 ? 'blue' : 'green'">
            {{ record.withdrawalAccount === 0 ? '余额' : '押金' }}
          </a-tag>
        </span>
        <span slot="withdrawalState" slot-scope="text, record">
          <a-tag :color="getWithdrawalStateColor(record.withdrawalState)">
            {{ getWithdrawalStateText(record.withdrawalState) }}
          </a-tag>
        </span>
        <span slot="withdrawalMoney" slot-scope="text"> ¥{{ text || 0 }} </span>
        <span slot="withdrawalFrontMoney" slot-scope="text"> ¥{{ text || 0 }} </span>
        <span slot="withdrawalAfterMoney" slot-scope="text"> ¥{{ text || 0 }} </span>
        <span slot="fee" slot-scope="text"> ¥{{ text || 0 }} </span>
        <span slot="withdrawalNo" slot-scope="text, record">
          <a-tooltip :title="record.withdrawalNo || '--'">
            <span class="text-ellipsis">{{ record.withdrawalNo || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="phone" slot-scope="text, record">
          <a-tooltip :title="record.phone || '--'">
            <span class="text-ellipsis">{{ record.phone || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="name" slot-scope="text, record">
          {{ (record.surname || '') + (record.name || '') || '--' }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          <a-tooltip :title="record.createTime || '--'">
            <span class="text-ellipsis">{{ record.createTime || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDetail(record)" v-hasPermi="['sys:fund:withdrawal:query']">详情</a>
          <a-divider
            type="vertical"
            v-hasPermi="['sys:fund:withdrawal:query', 'sys:fund:withdrawal:audit', 'sys:fund:withdrawal:remove']"
          />
          <a-dropdown v-hasPermi="['sys:fund:withdrawal:audit', 'sys:fund:withdrawal:remove']">
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon type="double-right" />
              更多
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-if="record.withdrawalState === 0" v-hasPermi="['sys:fund:withdrawal:audit']">
                <a @click="handleAudit(record)">审核</a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['sys:fund:withdrawal:remove']">
                <a @click="handleDelete(record)">删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <audit-modal ref="auditModal" @success="handleAuditSuccess" />
      <audit-statistics-modal ref="auditStatisticsModal" />
      <detail-drawer ref="detailDrawer" />
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchWithdrawalList, getWithdrawalStatistics, delWithdrawalObj } from '@/api/pressure/fund'
import DetailDrawer from './modules/DetailDrawer'
import AuditModal from './modules/AuditModal'
import AuditStatisticsModal from './modules/AuditStatisticsModal'
import moment from 'moment'

export default {
  name: 'FundWithdrawal',
  components: {
    DetailDrawer,
    AuditModal,
    AuditStatisticsModal,
  },
  data() {
    return {
      list: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        withdrawalNo: undefined,
        phone: undefined,
        nameA: undefined,
        withdrawalAccount: undefined,
        withdrawalType: undefined,
        withdrawalState: undefined,
        checkedAud: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        withdrawalExamineTimeStart: undefined,
        withdrawalExamineTimeEnd: undefined,
        sortField: undefined,
        sortOrder: undefined,
      },
      total: 0,
      createTimeValue: [],
      examineTimeValue: [],
      advanced: false,
      loading: false,
      tableSize: 'default',
      selectedRowKeys: [],
      selectedRows: [],
      single: true,
      multiple: true,
      ids: [],
      statisticsData: {
        undeliveredTotal: 0,
        withdrawnTotal: 0,
      },
      columns: [
        {
          title: '提现单号',
          dataIndex: 'withdrawalNo',
          key: 'withdrawalNo',
          scopedSlots: { customRender: 'withdrawalNo' },
          align: 'center',
          width: 180,
        },
        {
          title: '用户手机号',
          dataIndex: 'phone',
          key: 'phone',
          scopedSlots: { customRender: 'phone' },
          align: 'center',
          width: 120,
        },
        {
          title: '姓名',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: { customRender: 'name' },
          align: 'center',
          width: 100,
        },
        {
          title: '提现类型',
          dataIndex: 'withdrawalType',
          key: 'withdrawalType',
          scopedSlots: { customRender: 'withdrawalType' },
          align: 'center',
          width: 100,
        },
        {
          title: '提现账户',
          dataIndex: 'withdrawalAccount',
          key: 'withdrawalAccount',
          scopedSlots: { customRender: 'withdrawalAccount' },
          align: 'center',
          width: 100,
        },
        {
          title: '提现金额',
          dataIndex: 'withdrawalMoney',
          key: 'withdrawalMoney',
          scopedSlots: { customRender: 'withdrawalMoney' },
          align: 'center',
          width: 120,
        },
        {
          title: '手续费',
          dataIndex: 'fee',
          key: 'fee',
          scopedSlots: { customRender: 'fee' },
          align: 'center',
          width: 100,
        },
        {
          title: '提现前金额',
          dataIndex: 'withdrawalFrontMoney',
          key: 'withdrawalFrontMoney',
          scopedSlots: { customRender: 'withdrawalFrontMoney' },
          align: 'center',
          width: 120,
        },
        {
          title: '提现后金额',
          dataIndex: 'withdrawalAfterMoney',
          key: 'withdrawalAfterMoney',
          scopedSlots: { customRender: 'withdrawalAfterMoney' },
          align: 'center',
          width: 120,
        },
        {
          title: '审核状态',
          dataIndex: 'withdrawalState',
          key: 'withdrawalState',
          scopedSlots: { customRender: 'withdrawalState' },
          align: 'center',
          width: 100,
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center',
          width: 180,
        },
        {
          title: '操作',
          key: 'operation',
          align: 'center',
          width: 120,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
        },
      ],
    }
  },
  methods: {
    getWithdrawalTypeText(type) {
      const map = {
        0: '支付宝',
        1: '微信',
        2: '银行卡',
      }
      return map[type] || '未知'
    },
    getWithdrawalTypeColor(type) {
      const map = {
        0: 'blue',
        1: 'green',
        2: 'orange',
      }
      return map[type] || 'gray'
    },
    getWithdrawalStateText(state) {
      const map = {
        0: '审核中',
        1: '款项处理中',
        2: '提现成功',
        3: '提现失败',
        4: '打回',
      }
      return map[state] || '未知'
    },
    getWithdrawalStateColor(state) {
      const map = {
        0: 'orange',
        1: 'blue',
        2: 'green',
        3: 'red',
        4: 'purple',
      }
      return map[state] || 'gray'
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        withdrawalNo: undefined,
        phone: undefined,
        nameA: undefined,
        withdrawalAccount: undefined,
        withdrawalType: undefined,
        withdrawalState: undefined,
        checkedAud: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        withdrawalExamineTimeStart: undefined,
        withdrawalExamineTimeEnd: undefined,
        sortField: undefined,
        sortOrder: undefined,
      }
      this.createTimeValue = []
      this.examineTimeValue = []
      this.handleQuery()
    },
    getList() {
      this.loading = true
      fetchWithdrawalList(this.queryParam)
        .then((res) => {
          this.list = res.data.records || []
          this.total = res.data.total || 0
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    onChangeCreateTime(e) {
      if (e && e.length === 2) {
        this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD') + ' 00:00:00'
        this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
      } else {
        this.queryParam.createBeginTime = undefined
        this.queryParam.createEndTime = undefined
      }
    },
    onChangeExamineTime(e) {
      if (e && e.length === 2) {
        this.queryParam.withdrawalExamineTimeStart = moment(e[0]).startOf('day').format('YYYY-MM-DD') + ' 00:00:00'
        this.queryParam.withdrawalExamineTimeEnd = moment(e[1]).endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
      } else {
        this.queryParam.withdrawalExamineTimeStart = undefined
        this.queryParam.withdrawalExamineTimeEnd = undefined
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleDetail(record) {
      this.$refs.detailDrawer.init(record)
    },
    handleAuditStatistics() {
      this.$refs.auditStatisticsModal.init(this.queryParam)
    },
    handleExport() {
      const that = this
      this.$confirm({
        title: '导出数据',
        content: '确认导出当前筛选条件下的所有数据吗？',
        onOk() {
          that.download(
            'sys/fund/withdrawal/export',
            {
              ...that.queryParam,
            },
            `资金提现列表_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
    handleDelete(row) {
      const that = this
      let ids = []
      const postIds = row?.id || this.ids

      if (!postIds || (Array.isArray(postIds) && postIds.length === 0)) {
        this.$message.warning('请选择要删除的数据')
        return
      }

      if (row?.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }

      this.$confirm({
        title: '确认删除',
        content: `确定要删除选中的${ids.length}条数据吗？`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          const deleteData = ids.map((id) => ({ id }))
          delWithdrawalObj(deleteData)
            .then((res) => {
              if (res.success) {
                that.onSelectChange([], [])
                that.getList()
                that.getStatistics()
                that.$message.success('删除成功')
              } else {
                that.$message.error(res.message || '删除失败')
              }
            })
            .catch(() => {})
        },
        onCancel() {},
      })
    },
    getStatistics() {
      getWithdrawalStatistics({ type: this.queryParam.type })
        .then((res) => {
          if (res.success && res.data) {
            this.statisticsData = {
              undeliveredTotal: res.data.undeliveredTotal || 0,
              withdrawnTotal: res.data.withdrawnTotal || 0,
            }
          }
        })
        .catch(() => {})
    },
    handleAudit(record) {
      this.$refs.auditModal.init(record)
    },
    handleAuditSuccess() {
      this.getList()
      this.getStatistics()
    },
  },
  created() {
    this.getList()
    this.getStatistics()
  },
}
</script>

<style lang="less" scoped>
.text-ellipsis {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
